import { QueryClient } from "@tanstack/query-core";
import _ from "lodash";
import { useSnackBar } from "@truevault/aquilo";
import { QueryKey } from "@tanstack/react-query";

type ApiSnackbar = {
  apiSuccess: (msg: string) => void;
  apiError: (msg: string) => void;
};

export const useApiSnackbar = (): ApiSnackbar => {
  const enqueueSnackbar = useSnackBar();

  return {
    apiSuccess: (msg: string) => {
      enqueueSnackbar(msg, {
        variant: "success",
      });
    },
    apiError: (msg: string) => {
      enqueueSnackbar(msg, {
        variant: "error",
      });
    },
  };
};

export const updateQueryData = <T>(
  client: QueryClient,
  key: string[] | QueryKey,
  mutationFn: (x: T) => T | void,
) => {
  const data = client.getQueryData<T>(key);
  if (data) {
    const clone = _.cloneDeep(data);
    const result = mutationFn(clone);
    client.setQueryData(key, result ?? clone);
  } else {
    console.warn("Attempted to update query data when there is not current data.", key);
  }
};
